import { render, staticRenderFns } from "./SpkbAdjustDetail.vue?vue&type=template&id=0e97f923&"
import script from "./SpkbAdjustDetail.vue?vue&type=script&lang=js&"
export * from "./SpkbAdjustDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpkbAdjustDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports